import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";
export class SendInvitationPartner {
    constructor(private repository: PartnerSocketRepository) {}
	execute(params: SendInvitationPartnerParams): Promise<void> {
		return this.repository.sendInvitationPartner(params.id,params.user_id, params.match_id);
	}
}

export class SendInvitationPartnerParams {
	constructor(public id: string ,public user_id: string, public match_id: string) {}
}

